"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _LeaderboardOverview = _interopRequireDefault(require("./LeaderboardOverview"));

var _Tabs = _interopRequireDefault(require("../Tabs"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'leaderboard-overview';
exports.cssAnchorName = cssAnchorName;

var Leaderboard = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Leaderboard, _Component);

  var _super = _createSuper(Leaderboard);

  function Leaderboard(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Leaderboard);
    _this = _super.call(this, props);
    _this.state = {
      readyForPortal: false
    };
    return _this;
  }

  (0, _createClass2.default)(Leaderboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        readyForPortal: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isGuest = _this$props.isGuest,
          period = _this$props.period,
          loggedInUserId = _this$props.loggedInUserId;
      var readyForPortal = this.state.readyForPortal;
      var tabs = ['thisWeek', 'allTime'];
      var activeTab = period === 'thisWeek' ? 0 : 1;
      var tabTitles = tabs.map(function (tab) {
        return (0, _preact.h)(_phrase.default, {
          key: tab,
          p: "leaderboard.points.".concat(tab)
        });
      });
      return (0, _preact.h)("div", {
        className: "leaderboard-overview-container"
      }, (0, _preact.h)("div", {
        className: "leaderboard-header-container"
      }, (0, _preact.h)("div", {
        className: "leaderboard-title-container"
      }, (0, _preact.h)("h1", {
        className: "leaderboard-overview-title"
      }, ' ', (0, _preact.h)(_phrase.default, {
        p: "leaderboard.page.title"
      }), ' '), (0, _preact.h)("div", {
        className: "leaderboard-overview-subtitle"
      }, ' ', (0, _preact.h)(_phrase.default, {
        p: "leaderboard.page.subtitle"
      }), ' ')), (0, _preact.h)("div", {
        className: "leaderboard-time-period-container"
      })), readyForPortal && (0, _preact.h)(_Tabs.default, {
        titles: tabTitles,
        activeTab: activeTab,
        portalIntoClassName: ".leaderboard-time-period-container"
      }, tabs.map(function (tab) {
        return (0, _preact.h)(_LeaderboardOverview.default, {
          key: tab,
          tabTitle: tab,
          period: tab,
          isGuest: isGuest,
          loggedInUserId: loggedInUserId
        });
      })));
    }
  }]);
  return Leaderboard;
}(_preact.Component);

exports.default = Leaderboard;